import { type CreateJobWizardViewLoaderData } from '@src/views/createJobWizard/createJobWizardView.loader.ts';
import { LoadingSpinner } from '@src/components/LoadingSpinner';
import { Suspense, lazy } from 'react';
import { useLoaderData } from 'react-router-dom';
import JobWizardContext from '@components/jobWizard/JobWizardContext.tsx';
import type { JobForWizard } from '@src/api/queries/job';

export default function JobWizardView() {
  const loaderData = useLoaderData() as CreateJobWizardViewLoaderData;
  return (
    <JobWizardContext.Provider value={loaderData}>
      <Suspense fallback={<LoadingSpinner />}>
        <JobWizard initialValue={loaderData.job as JobForWizard} />
      </Suspense>
    </JobWizardContext.Provider>
  );
}

const JobWizard = lazy(() => import('@components/jobWizard/JobWizard.tsx'));
